export { default as component } from "../../../../src/routes/(app)/roast/+page.svelte";